import Carson1 from '../Carson/Carson (1).webp'
import Carson2 from '../Carson/Carson (2).webp'
import Carson3 from '../Carson/Carson (3).webp'

const Carsonimages =[
Carson1,Carson2,Carson3
]

export default Carsonimages;